/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable react/prop-types */
import { DeleteOutlined, EditOutlined, KeyOutlined, PlusOutlined, UploadOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Popconfirm, Space, Tooltip, message } from 'antd';
import Card from 'components/Containers/Card';
import { query, queryFirst } from 'helpers/QueryHelper';
import DynamicForm from 'packages/DynamicForm/components/DynamicForm';
import DynamicTable from 'packages/DynamicForm/components/DynamicTable';
import ExcelRegister from 'pages/Administration/ExcelRegister';
import ManualRegister from 'pages/Administration/ManualRegister';
import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import colors from 'constants/colors';
import formData from './formData';
import defaultTableData from './tableData';
import ChangePasswordPopup from './components/ChangePasswordPopup';

type Parameters = {
  email: string;
  phone: string;
  roleId: number;
  schoolTypeId: number;
  countQuery?: number;
};

export default () => {
  const [parameters, setParameters] = React.useState<Parameters>({ email: '', phone: '', roleId: 1, schoolTypeId: 5, countQuery: 0 });
  const [loading, setLoading] = React.useState<boolean>(false);
  const [registerModal, setRegisterModal] = useState<'insert' | 'update' | null>(null); // 0 - close modal , >=1 - open modal
  const [openModal_excel, setOpenModal_excel] = useState(0);
  const [openModal_password, setOpenModal_password] = useState({
    email: '',
    fullName: '',
  });
  const [currentRecord, setCurrentRecord] = useState<any>(null);
  const [isMobile, setIsMobile] = useState(false);

  const tableData = {
    ...defaultTableData,
    displayColumns: [
      defaultTableData.displayColumns?.[0],
      {
        ...defaultTableData.displayColumns?.[1],
        fixed: isMobile ? false : 'left',
        render: (value: any, record: any) => {
          return (
            // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
            <span
              onClick={() => {
                setCurrentRecord(record);
                setRegisterModal('update');
              }}
              title={value}
              className='tw-uppercase tw-truncate tw-inline-block tw-cursor-pointer hover:tw-underline'
              style={{ color: colors.font, fontWeight: 600, maxWidth: 250 }}
            >
              <UserOutlined className='tw-mr-2' />
              {value}
            </span>
          );
        },
      },
      ...defaultTableData.displayColumns?.slice(2),
    ],
  };

  useEffect(() => {
    // Simple resize listener
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // mobile breakpoint
    };

    handleResize(); // check on load
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const key = ['Users', parameters];
  const { data, isLoading } = useQuery(key, () => {
    const { countQuery, ...params } = parameters;
    return query('p_SACHSO_USERS_Search', params);
  });

  const onRefeshData = () => {
    setParameters((prev) => ({ ...prev, countQuery: prev.countQuery + 1 }));
  };

  const onDeleteUser = async (id: number) => {
    setLoading(true);
    await queryFirst('p_SACHSO_USERS_Delete', { userId: id })
      .then((res) => {
        message.success('Xoá thành công!');
        onRefeshData();
      })
      .catch((rer) => {
        message.error('Xoá thất bại!');
      });
    setLoading(false);
  };

  const onCloseRegisterModal = () => {
    setRegisterModal(null);
    setCurrentRecord(null);
  };

  return (
    <React.Fragment>
      <Card
        title='Quản lý người dùng'
        extra={
          <div className='tw-flex tw-flex-wrap tw-justify-center tw-content-center tw-gap-1 tw-max-w-full'>
            <Button
              onClick={() => {
                setRegisterModal('insert');
              }}
              className='tw-flex-1'
            >
              <PlusOutlined /> Thêm người dùng
            </Button>
            <Button
              onClick={() => {
                setOpenModal_excel((prev) => prev + 1);
              }}
              className='tw-flex-1'
            >
              <UploadOutlined /> Nhập từ excel
            </Button>
          </div>
        }
      >
        <DynamicForm
          initialFormData={formData}
          loading={isLoading}
          onSubmit={(values: Parameters) => {
            setParameters(values);
          }}
          onError={undefined}
          onExportToExcel={undefined}
          initialValues={undefined}
          onValuesChange={undefined}
          formInstance={undefined}
        />
        <DynamicTable
          loading={isLoading}
          dataSource={data}
          initialTableData={tableData}
          extraColumns={[
            {
              title: '',
              key: 'action',
              width: '1%',
              sort: false,
              render: (_: any, record: any) => {
                return (
                  <Space>
                    <Tooltip placement='top' title='Chỉnh sửa thông tin'>
                      <Button
                        key='edit-user'
                        shape='circle'
                        type='dashed'
                        // style={{ color: 'green' }}
                        icon={<EditOutlined />}
                        onClick={() => {
                          setCurrentRecord(record);
                          setRegisterModal('update');
                        }}
                      />
                    </Tooltip>
                    <Tooltip placement='top' title='Đổi mật khẩu'>
                      <Button key='edit-password' shape='circle' type='dashed' style={{ color: 'blue' }} icon={<KeyOutlined />} onClick={() => setOpenModal_password({ email: record.email, fullName: record.fullName })} />
                    </Tooltip>
                    <Popconfirm
                      placement='topRight'
                      title={() => {
                        return (
                          <div>
                            <p style={{ fontSize: 14, fontWeight: 400 }}>
                              Bạn có chắc chắn muốn xoá tài khoản &nbsp;
                              <strong>{record.email}</strong>?
                            </p>
                            <strong style={{ color: '#f5222d' }}>Sau khi xoá, dữ liệu sẽ không khôi phục được</strong>
                          </div>
                        );
                      }}
                      onConfirm={() => onDeleteUser(record.id)}
                      okButtonProps={{
                        loading,
                      }}
                      okText='Xoá'
                      cancelText='Đóng'
                    >
                      <Tooltip placement='top' title='Xoá tài khoản'>
                        <Button key='delete-user' shape='circle' type='dashed' danger style={{ color: '#f5222d' }} icon={<DeleteOutlined />} />
                      </Tooltip>
                    </Popconfirm>
                  </Space>
                );
              },
            },
          ]}
          pagination={{ defaultPageSize: 10 }}
          onReload={undefined}
        />
      </Card>
      <ManualRegister isOpen={registerModal} onCloseRegisterModal={onCloseRegisterModal} onRefeshData={onRefeshData} record={currentRecord} />
      <ExcelRegister isOpen={openModal_excel} onRefeshData={onRefeshData} />
      <ChangePasswordPopup userInfor={openModal_password} />
    </React.Fragment>
  );
};
